import { EMAIL, SITE_URL, SOCIAL_FACEBOOK, SOCIAL_LINKEDIN } from "./constants";

const website = {
    author: "Skywire Ltd",
    ogLanguage: "en_GB",
    siteLanguage: "en-GB",
    siteTitle: "Skywire | Luxury Digital Agency & Growth Partner",
    siteShortTitle: "Skywire Ltd",
    siteDescription:
        "Luxury digital agency and growth partner combining technology and engineering, creative experience and performance marketing.",
    siteUrl: SITE_URL,
    backgroundColor: "#1b4079",
    themeColor: "#d62828",
    contactEmail: EMAIL,
    facebookPage: SOCIAL_FACEBOOK,
    linkedinProfile: SOCIAL_LINKEDIN,
};

export { website as default };
